import { render, staticRenderFns } from "./SelfDefense.vue?vue&type=template&id=46e2e53c&scoped=true"
import script from "./SelfDefense.vue?vue&type=script&lang=js"
export * from "./SelfDefense.vue?vue&type=script&lang=js"
import style0 from "./SelfDefense.vue?vue&type=style&index=0&id=46e2e53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e2e53c",
  null
  
)

export default component.exports